export const getInitialState = () => ({
  cart: [],
});

export const state = getInitialState();



// WEBPACK FOOTER //
// ./src/store/modules/cart/state.js